import { Alert } from '@rikstv/shared-components';

import { useLocalStorage } from '../../hooks/useLocalStorage';
import { getAppLink, isAndroid } from '../../utils/device/device.utils';
import { AppStoreBadge } from '../appstore/AppStoreBadge';
import { PlayStoreBadge } from '../appstore/PlayStoreBadge';

import styles from './AppStoreNotificationBanner.module.css';

export const AppStoreNotificationBanner = () => {
  const appLink = getAppLink();
  const [bannerDismissed, setDismissed] = useLocalStorage<boolean>('appstore-notification-banner-dismissed', false);
  const showBanner = appLink && bannerDismissed === false;
  if (!showBanner) {
    return null;
  }
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <Alert className={styles.alert} heading="Last ned appen her!" intent="info" onDismissed={() => setDismissed(true)}>
      {isAndroid ? <PlayStoreBadge href={appLink} /> : <AppStoreBadge href={appLink} />}
    </Alert>
  );
};
